export default "__VITE_PUBLIC_ASSET__45893ffc__"